var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReboot(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#11192A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M18 4.066c-2.938-2.293-6.926-2.712-10.275-1.078C4.375 4.623 2.25 8.023 2.25 11.75V14M6 19.439c2.939 2.293 6.927 2.71 10.277 1.075 3.35-1.635 5.474-5.037 5.473-8.764V9.5",
    transform: "translate(0 -1)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#11192A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M.75 12.5L2.25 14 3.75 12.5M23.25 11L21.75 9.5 20.25 11M12 6.698L12 10.448M8.818 8.766c-1.757 1.757-1.757 4.607 0 6.364 1.757 1.757 4.607 1.757 6.364 0 1.757-1.757 1.757-4.607 0-6.364",
    transform: "translate(0 -1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0H24V24H0z",
    transform: "translate(0 -1)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReboot);
export default __webpack_public_path__ + "static/media/reboot.1fbd9e1f46a6dc3192db2d0d6b937a1e.svg";
export { ForwardRef as ReactComponent };